import { useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import EmailFormModal from '../Components/EmailModal.js'; // Import the modal component
import '../CSS/Orgs.css';

const OrgDetailsPage = () => {
  const { id } = useParams(); // Get the ID from the URL parameter

  const [orgs, setOrgs] = useState([]);
  const [reports, setReports] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false); // State for modal visibility

   // --- Helper Functions ---
   const getUserEmail = () => {
    const customEmail = localStorage.getItem('custom-email');
    if (customEmail) return customEmail;

    const msalAccount = JSON.parse(localStorage.getItem('msal.account') || 'null');
    return msalAccount?.username || '';
  };

  const openReport = (linkUrl, reportType = 'GroupsReports') => {
    const userEmail = localStorage.getItem('user-email'); // ✅ Unified email
    if (!userEmail) {
      alert('You must be logged in to view this report.');
      return;
    }
  
    const parts = linkUrl.split('/');
    const filename = parts[parts.length - 1];
  
    // Pass user email as a query param (headers don’t work with window.open)
    const encodedFilename = encodeURIComponent(filename);
    const encodedEmail = encodeURIComponent(userEmail);
    const reportUrl = `/api/reports/${encodedFilename}?email=${encodedEmail}`;

    if (userEmail) {
      // Fire-and-forget log (non-blocking)
      fetch('/api/log-report', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        keepalive: true, // lets it complete even if page navigates
        body: JSON.stringify({
          reportName: filename,      // goes into Title column
          reportType,                // the page/section (you can pass "Highlights", "Calendar", etc.)
          userEmail                  // goes into ClickedBy
        })
      }).catch(() => {}); // don’t break UX if logging fails
    }
  
    window.open(reportUrl, '_blank');
  };


  useEffect(() => {
    // Fetch orgs data from your server
    fetch('/api/hello')
      .then((response) => response.json())
      .then((data) => {
        setOrgs(data.orgs);
        setReports(data.reports);
      })
      .catch((error) => {
        console.error('Error fetching orgs data:', error);
      });
  }, []);

  // Find the organization with the matching ID
  const selectedOrg = orgs.find((org) => org.fields.id === id);

  if (!selectedOrg) {
    return <div>Organization not found</div>;
  }

  const profileLink = selectedOrg.fields.ProfileLink;

  const orgTitle = selectedOrg.fields.Title;

  const akaDash = '- ' + selectedOrg.fields.AKA;

  // ✅ Build proxy URL if a profile link exists
  const profileProxyLink = profileLink
  ? `/api/highlights/Profiles/${encodeURIComponent(
      profileLink.split('/').pop()
    )}`
  : null;




  /* Filter reports based on the specified field that links to the organization
  const orgReports = reports.filter(
    (report) => report.fields.field_10 === orgTitle || report.fields.field_10 === selectedOrg.fields.OldName
  );*/

  const orgReports = reports.filter(report => {
    // Get the legacy field, trimming any whitespace. If undefined, default to an empty string.
    const oldData = report.fields.field_10 ? report.fields.field_10.trim() : "";
    
    // Normalize the expected organization names
    const expectedOrg1 = orgTitle ? orgTitle.trim() : "";
    const expectedOrg2 = selectedOrg.fields.OldName ? selectedOrg.fields.OldName.trim() : "";
    
    // Only consider a legacy match if oldData is non-empty.
    const legacyMatch = oldData !== "" && (oldData === expectedOrg1 || oldData === expectedOrg2);
  
    // Check the new field (groupresponsibleLU) if it's an array.
    let newDataMatch = false;
    if (Array.isArray(report.fields.GroupResponsibleLU)) {
      newDataMatch = report.fields.GroupResponsibleLU.some(item => {
        const lookupVal = item.LookupValue ? item.LookupValue.trim() : "";
        const matchResult = (lookupVal === expectedOrg1 || lookupVal === expectedOrg2);
        return matchResult;
      });
    }
  
    /*console.log(
      `Report: "${report.fields.Title}" - legacy field: "${oldData}", expectedOrg1: "${expectedOrg1}", expectedOrg2: "${expectedOrg2}", legacyMatch: ${legacyMatch}, newDataMatch: ${newDataMatch}`
    );*/
  
    return legacyMatch || newDataMatch;
  });
  
  
  
  

  // Handlers for modal open/close
  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  return (
    <div className="orgs">
      <h1>{selectedOrg.fields.Title} {selectedOrg.fields.AKA && akaDash}</h1>
      {selectedOrg.fields.OldName && <h2>Prior Name : {selectedOrg.fields.OldName}</h2>}
      {/* Display other details of the selected organization */}
      {/* For example: <p>Description: {selectedOrg.fields.Description}</p> */}
      {profileLink ? (
            <a
              href={profileProxyLink || profileLink}  // ✅ Use proxy if available
              className="profiles"
              target="_blank"
              rel="noopener noreferrer"
            >
              Link to Organization Profile
            </a>
          ) : (
            <p>
              No profile exists.{' '}
              <button className="contact-button" onClick={handleOpenModal}>
                Click here to contact us.
              </button>
            </p>
          )}


      {/* Display reports related to the organization */}
      <h3>Reports Involving {selectedOrg.fields.Title}</h3>
      <div className="reports-grid">
        <div className="reports-header">
          <div className="header-item">Title</div>
          <div className="header-item">Date</div>
          <div className="header-item">Country</div>
          <div className="header-item">Sector</div>
        </div>
        {orgReports.map((report) => (
          <div className="report-row" key={report.fields.Id}>
            {report.fields.Links1 ? (
           <a
           href="#"
           onClick={(e) => {
             e.preventDefault(); // Prevent default navigation
             openReport(report.fields.Links1); // ✅ Use unified email
           }}
           className="report-item report-title" // Keep original styling
           data-label="Title"
         >
           {report.fields.Title}
         </a>
         
          ) : (
            <div className="report-item" >{report.fields.Title}</div>
          )}
            <div className="report-item">{report.fields.field_1_formatted}</div>
            <div className="report-item">{report.fields.field_3}</div>
            <div className="report-item">{report.fields.field_6}</div>
          </div>
        ))}
      </div>

      {/* Modal for Email Form */}
      <EmailFormModal 
      isOpen={isModalOpen} 
      onClose={handleCloseModal}
      orgName={selectedOrg.fields.Title}
      />
    </div>
  );
};

export default OrgDetailsPage;
